import Head from 'next/head';
import { type ReactNode, useEffect } from 'react';

import Carousel from '@components/Artwork/Carousel';
import { hexToRgb } from '@utils';
import { resolveShareTitle } from '@utils/eventMeta';
import { withErrorBoundary } from '@utils/errorHandler';

interface IEventWrapperProperties {
  event: IEvent;
  eventSeries?: IEventSeries;
  children: ReactNode;
}

export const EventWrapper = ({
  children,
  event,
  eventSeries,
}: IEventWrapperProperties) => {
  const {
    Background,
    Backgrounds,
    ColourBackground,
    ColourPrimary,
    ColourSecondary,
    ColourDetail,
    SystemColour,
  } = event;
  const title = resolveShareTitle(event, eventSeries);
  const hasCustomMedia = Backgrounds?.some(bg => bg.Order > 0);
  const slides: SlideType[] = Backgrounds?.filter(
    bg => !hasCustomMedia || bg.Order > 0
  )
    .sort((a, b) => a.Order - b.Order)
    .map(({ Url, Order, Key }) => ({ Url, Order, Key }));

  useEffect(
    withErrorBoundary(() => {
      document.documentElement.style.setProperty(
        '--background-colour',
        hexToRgb(eventSeries?.ColourBackground ?? ColourBackground)
      );
      document.documentElement.style.setProperty(
        '--primary-colour',
        hexToRgb(eventSeries?.ColourPrimary ?? ColourPrimary)
      );
      document.documentElement.style.setProperty(
        '--secondary-colour',
        hexToRgb(eventSeries?.ColourSecondary ?? ColourSecondary)
      );
      document.documentElement.style.setProperty(
        '--detail-colour',
        hexToRgb(eventSeries?.ColourDetail ?? ColourDetail)
      );
      document.documentElement.style.setProperty(
        '--system-colour',
        hexToRgb(eventSeries?.SystemColour ?? SystemColour)
      );
      document.documentElement.style.setProperty(
        '--background-url',
        `url('${eventSeries?.Background ?? Background}')`
      );
      document.documentElement.style.background = `rgb(${hexToRgb(
        eventSeries?.ColourBackground ?? ColourBackground
      )})`;
    }),
    [event, eventSeries]
  );

  return (
    <>
      <Head>
        <title>{`${title} | Scope Tickets`}</title>
        <meta name='theme-color' content='#000000' />
      </Head>
      <div id='wrapper'>
        <div className='content' id='content'>
          <div className='appLandingContainer'>
            <section className='desktopLeft'>
              <div className='artworkHeroContainer'>
                <div className='artworkHero'>
                  {slides ? (
                    <Carousel slides={slides} />
                  ) : (
                    <img
                      src={eventSeries?.Background ?? Background}
                      alt='Event Background'
                    />
                  )}
                </div>
              </div>
            </section>
            <section className='desktopRight'>{children}</section>
          </div>
        </div>
      </div>
    </>
  );
};
